import { DrawerFooter } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Button } from '@/components/ui/button'
import { VStack } from '@/components/ui/stack'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'

const EmptyDrawerFooter = ({ onClose }: { onClose: () => void }) => {
    const { t } = useTranslation()
    const borderColor = useColorModeValue('gray.300', 'gray.700')

    return (
        <DrawerFooter borderTopWidth="1px" borderColor={borderColor} px="0" py="24px" justifyContent="flex-start">
            <VStack align="flex-start">
                <Box mb="24px">
                    <Text
                        fontSize="14px"
                        fontFamily="GSKPrecision-Bold"
                        fontWeight="bold"
                        letterSpacing="0.25px"
                        as="span"
                        maxW="340px"
                        display="inline-block"
                    >
                        {t('translate.invalidCharactersFileName.info')}
                    </Text>
                </Box>
                <Box>
                    <Button variant="secondary" mr="18px" onClick={onClose}>
                        {t('translate.drawer.buttons.close')}
                    </Button>
                </Box>
            </VStack>
        </DrawerFooter>
    )
}

export default EmptyDrawerFooter
